import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  mappingStatus: z.enum(["classified", "unclassified", "modified"]).optional(),
});

export const Route = createFileRoute(
  "/_protected/corporate-finance/projects/$id/_project-tabs/input-process/classification",
)({
  validateSearch: searchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/corporate-finance/projects/$id/account-mapping",
      params: { id: params.id },
      search: {
        entityProjectId: search.entityProjectId,
        mappingStatus: search.mappingStatus,
      },
      replace: true,
    });
  },
});
